import { effect, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationStateService {
  private personalAccessTokenSignal = signal<string | null>(null);
  readonly personalAccessToken = this.personalAccessTokenSignal.asReadonly();

  constructor() {
    effect(() => {
      const personalAccessToken = this.personalAccessTokenSignal();
      if (personalAccessToken !== null) {
        sessionStorage.setItem('personalAccessToken', personalAccessToken);
      }
    });
  }

  setPersonalAccessToken(value: string) {
    this.personalAccessTokenSignal.set(value);
  }
}
